<template>
    <div>
        <!-- testimonial Section start-->
        <section id="testimonial" class="testimonial">
            <div class="testimonial-decor">
                <div class="testi-circle1">
                    <img :src="'../assets/images/Testimonial2.png'" alt="" />
                </div>
                <div class="testi-circle2">
                    <img :src="'../assets/images/Testimonial1.png'" alt="" />
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 offset-lg-1">
                        <carousel
                            :className="'testimonial-carousel '"
                            :loop="true"
                            :margin="30"
                            :items="1"
                            :center="true"
                            :nav="true"
                            :dots="false"
                            :dotsEach="false"
                            :autoplay="false"
                            :responsive="{
                                0: { items: 1, dots: true, nav: false },
                                768: { items: 1, dots: true, nav: false },
                                992: { nav: true }
                            }"
                        >
                            <div class="testimonial-item">
                                <div class="testimonial-block">
                                    <div class="testimonial-avtar">
                                        <img
                                            :src="require('../assets/images/avtar/DH_logo.jpg')"
                                            alt=""
                                        />
                                    </div>
                                    <div class="testimonial-text">
                                        <p>
                                            Xtreme's help and support on what was a massive project
                                            for us here at Drexler was invaluable. The project was our
                                            first commercial system at considerable scale and we were
                                            apprehensive when we approached its design and
                                            implementation.
                                        </p>
                                        <p>
                                            The whole system revolved around the crestron architecture
                                            on the Microsoft teams platform. You gave us a way to
                                            structure the installation rollout via product connection
                                            sheets. Your confidence and skill in this area helped
                                            build our confidence and got us over the line on time and
                                            on budget.
                                        </p>
                                        <p>
                                            When you recommended that we use and install your RMS
                                            support system we installed it without hesitation. This
                                            has enabled us to build, with the client and effective
                                            support role that exceeds expectations.
                                        </p>
                                        <p>
                                            We consider Xtreme a crucial part of our team and can now
                                            chase projects that may have been out of our skill sets
                                            before. We are all looking forward to working with you
                                            again.
                                        </p>
                                        <h3>James Davies</h3>
                                        <h6>Managing Director - Drexler Hooke</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="testimonial-item">
                                <div class="testimonial-block">
                                    <div class="testimonial-avtar">
                                        <img
                                            :src="require('@/assets/images/avtar/olivier.png')"
                                            alt=""
                                        />
                                    </div>
                                    <div class="testimonial-text">
                                        <p>
                                            Having worked with Xtreme on very two very complicated
                                            installations, I found their reliability and efficiency
                                            far above expectation and will keep using their services
                                            for current and future projects, Highly recommended.
                                        </p>
                                        <h3>Olivier Delaunoy</h3>
                                        <h6>Cheif Technical Officer - Bloc Hotels</h6>
                                    </div>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>
        </section>
    <!-- testimonial Section End -->
    </div>
</template>
<script>
export default {
    name: "Testimonial"
}
</script>



// WEBPACK FOOTER //
// src/components/testimonial.vue